import styled from "styled-components";

export const StyledMainContainer = styled.main`
  height: 100%;
  width: 100%;
`;

export const StyledLoading = styled.section`
  margin: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10000;
`;
